export default "__VITE_ASSET__8GeBZeJ6__"